module.exports = __webpack_public_path__ + "static/pic-profile-member-2-f71a2a66c15911ab920082b30c92c92a.png";